import { makeStyles } from 'tss-react/mui';

import { colors } from '@src/theme/colors';

const useStyles = makeStyles<{ isCenter: boolean; size: number }>()(
  (_theme, { isCenter, size }) => ({
    loader: {
      display: 'flex',
      // Static import, NOT theme.palette.custom: Loader renders as the
      // top-level Suspense fallback in main.tsx — OUTSIDE the ThemeProvider —
      // where palette.custom does not exist (that's why this used to be a
      // hardcoded hex).
      color: colors.text.white,
      height: 36,
      width: 36,

      ...(isCenter && {
        position: 'absolute' as const,
        top: `calc(50% - ${size / 2}px)`,
        left: `calc(50% - ${size / 2}px)`,
        transform: 'translate(-50%, -50%)',
      }),
    },
  }),
);

export default useStyles;
